import Basic from '@/views/backstage/structure/detail_page/common/BasicStructure'
import Rights from '@/views/backstage/structure/detail_page/common/RightsStructure'
import PhysicalObject from '@/views/backstage/structure/detail_page/common/PhysicalObjectStructure'
import ForestryData from '@/views/backstage/structure/detail_page/common/ForestryDataStructure'

let OralHistoryFields = {
    'respondent_name': {
        display: {
            name: '受訪者',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'respondent_name',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'respondent_introduction': {
        display: {
            name: '受訪者簡介',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'respondent_introduction',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'respondent_era_ad': {
        display: {
            name: '受訪者出生年(西元)',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'respondent_era_ad',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'respondent_era_none_ad': {
        display: {
            name: '受訪者出生年(非西元)',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'respondent_era_none_ad',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'interview_location': {
        display: {
            name: '訪談地點',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'interview_location',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multi-string'
        }
    },
    'interview_date': {
        display: {
            name: '訪談日期',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'interview_date',
            data_type: 'datetime',
        },
        change: {
            editable: true,
            addable: true,
            type: 'datetime'
        }
    },
    'interviewer': {
        display: {
            name: '訪談者',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'interviewer',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multi-string'
        }
    },
    'handle_man': {
        display: {
            name: '經手人',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'handle_man',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
}

let OralHistory = (front_back) => {

    let fields = null
    if (front_back === 'backstage') {
        fields = [
            OralHistoryFields['respondent_name'],
            OralHistoryFields['respondent_introduction'],
            OralHistoryFields['respondent_era_ad'],
            OralHistoryFields['respondent_era_none_ad'],
            OralHistoryFields['interview_location'],
            OralHistoryFields['interview_date'],
            OralHistoryFields['interviewer'],
            OralHistoryFields['handle_man'],
        ]
    }
    else {
        fields = [
            OralHistoryFields['respondent_name'],
            OralHistoryFields['respondent_introduction'],
            // OralHistoryFields['respondent_era_ad'],
            // OralHistoryFields['respondent_era_none_ad'],
            // OralHistoryFields['interview_location'],
            OralHistoryFields['interview_date'],
            // OralHistoryFields['interviewer'],
            // OralHistoryFields['handle_man'],
        ]
    }

    return {
        name: '口述歷史資料',
        type: 'group',
        fields
    }
}

export default (front_back = 'backstage') => {
    
    let candidates = [].concat(
        Basic('oral_history', front_back),
        ForestryData('oral_history', front_back),
        OralHistory(front_back), 
        Rights('oral_history', front_back), 
        PhysicalObject('oral_history', front_back))
    
    let fields = candidates.filter( x => x.fields.length > 0)    

    return {
        name: '口述史料類',
        type: 'group',
        fields
    }    
}
    